export default __webpack_public_path__ + "static/media/shipka_peppers.31691f23.png";